module.exports = __webpack_public_path__ + "static/media/10.2e59da9b.jpg";